const allowedVerificationMethods = () => {
    const verDefault = ['email', 'sms'];
    const allowed = process.env.REACT_APP_ALLOWED_VERIFICATION_METHODS
        ?.split(',')
        .filter(x => ['email', 'sms'].includes(x));

    return allowed?.length ? allowed : verDefault;
}

export const ALLOWED_VERIFICATION_METHODS = allowedVerificationMethods()

export const TURNSTILE_ENABLED = process.env.REACT_APP_CF_TURNSTILE_SITE_KEY && process.env.REACT_APP_CF_TURNSTILE_ENABLED === 'true'